<template>
  <div>
    <div class="add-user-role">
      <div class="title">
        <h1>{{ $t('base_user_item_step_role.qsyygyxgw') }}</h1>
        <p>{{ $t('base_user_item_step_role.ygjyybsygwdtdgnqx') }}</p>
      </div>
      <div class="role-list">
        <ul>
          <li class="ub ub-sp" :class="{ cur: item.selected }" v-for="item in roleList" :key="item.roleId">
            <el-checkbox v-model="item.selected">{{ item.roleName }}</el-checkbox>
            <i class="icon icon-tiaoshi" @click="openRolePer(item)" v-if="item.roleType != 5"></i>
          </li>
          <li class="add-role" @click="addRole">
            <i class="el-icon-plus"></i>
            {{ $t('base_user_item_step_role.xin_zeng_gang_wei') }}
          </li>
        </ul>
      </div>
      <div class="title">
        <h1>{{ $t('base_user_item_step_role.ygxyjssmlxdxx') }}</h1>
        <p>{{ $t('base_user_item_step_role.qxzygxyjsdxxlx') }}</p>
      </div>
      <div class="sms-list">
        <ul>
          <li v-for="item in msgRoleList" :key="item.roleId">
            <el-checkbox v-model="item.selected">{{ item.roleName }}</el-checkbox>
            <!-- <span v-if="item.roleCode === 'MSG_DEVICE'" class="more" @click="showMsgList">更多</span> -->
          </li>
        </ul>
      </div>
    </div>
    <div class="footer">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button @click="onBack">{{ $t('base_user_item_step_role.shang_yi_bu') }}</el-button>
      <el-button type="primary" @click="saveRoleUser">{{ $t('Common.com_finish') }}</el-button>
    </div>
    <role-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="successAddRole"></role-dialog>
    <custom-dialog width="72%" :title="$t('base_user_item_step_role.gong_neng_quan_xian')" :visible="dialogVisible2" @close="dialogVisible2 = false">
      <div style="height: 680px; display: flex; flex-direction: column">
        <role-permission type="dialog" :roleId="roleId" :orgId="orgId" @success="dialogVisible2 = false"></role-permission>
      </div>
    </custom-dialog>
    <msg-list-dialog v-if="msgListDialogVisible" @close="msgListDialogVisible = false" :model="msgListDialogModel"></msg-list-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import rolePermission from '@/pages/base/components/rolePermission.vue';
import roleDialog from '@/pages/base/components/roleDialog.vue';
import msgListDialog from './msg_list_dialog';

export default {
  components: {
    roleDialog,
    rolePermission,
    msgListDialog,
  },
  props: {
    userId: [String, Number],
    userName: String,
  },
  data() {
    return {
      roleId: '',
      msgRoleType: '',
      msgServiceType: '',
      roleList: [],
      msgServiceList: [],
      msgRoleList: [],
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      msgListDialogVisible: false,
      msgListDialogModel: {},
      orgId: '',
    };
  },
  computed: {
    isAdmin() {
      return this.$store.state.userInfo.bizType === 'PF';
    },
  },
  mounted: function () {
    this.orgId = this.getJump('orgId');
    this.getDictionary('bas_role_type', (data) => {
      const msgRoleType = data.bas_role_type.find(t => t.code === 'notice_role') || {};
      const msgServiceType = data.bas_role_type.find(t => t.code === 'service_role') || {};
      this.msgRoleType = msgRoleType.value || '';
      this.msgServiceType = msgServiceType.value || '';
      this.getRoleList();
    });
  },
  methods: {
    // 设备类型消息-消息列表
    showMsgList() {
      this.msgListDialogModel = {
        title: this.$t('base_user_item_step_role.xiao_xi_lie_biao'),
      };
      this.msgListDialogVisible = true;
    },
    onCancel: function () {
      this.$emit('cancel');
    },
    onBack: function () {
      this.$emit('back');
    },
    // 获取岗位列表
    getRoleList: function () {
      this.$getJSON(apis.UserRoleAll, { isShowNotice: 1, isShowService: 1, orgId: this.orgId, userId: this.userId }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.selected = false;
        });
        // 服务类型
        this.msgServiceList = list.filter(t => `${t.roleType}` === `${this.msgServiceType}` && t.state === 1);
        // 消息类型
        this.msgRoleList = list.filter(t => `${t.roleType}` === `${this.msgRoleType}` && t.state === 1);
        // 自定义
        const roleList = list.filter(t => `${t.roleType}` !== `${this.msgRoleType}` && t.state === 1 && `${t.roleType}` !== `${this.msgServiceType}` && t.state === 1);

        this.roleList = [...this.msgServiceList, ...roleList];
        this.getUserRoleList();
      });
    },
    // 获取用户关联的岗位
    getUserRoleList: function () {
      if (!this.userId) {
        return;
      }
      this.$getJSON(apis.UserRole, { bizId: this.userId }).then((res) => {
        const userRoleIds = res.data.map(t => t.roleId);
        this.roleList.forEach((item) => {
          item.selected = userRoleIds.includes(item.roleId);
        });
        this.msgRoleList.forEach((item) => {
          item.selected = userRoleIds.includes(item.roleId);
        });
      });
    },
    // 新增岗位
    addRole: function () {
      this.dialogModel1.type = 'add';
      this.dialogModel1.title = this.$t('base_user_item_step_role.xin_zeng_gang_wei');
      this.dialogModel1.orgId = this.orgId;
      this.dialogVisible1 = true;
    },
    // 新增岗位成功
    successAddRole: function () {
      this.clearKeepAlive('role');
      this.getRoleList();
    },
    // 用户批量关联岗位
    saveRoleUser: function () {
      const roleIds = [...this.roleList, ...this.msgRoleList].filter(t => t.selected).map(f => f.roleId);

      if (!roleIds.length) {
        // 如果为管理员不校验
        if (this.isAdmin) {
          this.clearTagByKeep('user_item');
          // this.jump('/company/user', {}, true);
          const parentPath = this.getJump('parentPath');
          this.jump(parentPath, {}, true);
          return;
        }
        this.$message.error(this.$t('base_user_item_step_role.qzsxzyggw'));
        return;
      }
      this.$postJSON(apis.UserRoleAdd, {
        bizId: this.userId,
        bizName: this.userName,
        bizType: 3,
        roleIds: roleIds,
      }).then(() => {
        this.$message({
          type: 'success',
          message: this.$t('Common.com_handle_success'),
        });
        this.clearTagByKeep('user_item');
        // this.jump('/company/user', {}, true);
        const parentPath = this.getJump('parentPath');
        this.jump(parentPath, {}, true);
      });
    },
    // 配置岗位权限
    openRolePer: function (item) {
      this.roleId = item.roleId;
      this.dialogVisible2 = true;
    },
  },
};
</script>

<style lang="scss">
@import '@/style/mixin.scss';
.add-user-role {
  .title {
    h1 {
      color: #495057;
      font-size: 14px;
      line-height: 20px;
      font-weight: bold;
    }
    p {
      color: #98a6ad;
      font-size: 12px;
      margin-top: 16px;
      margin-bottom: 20px;
      line-height: 17px;
    }
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 22px;
  }
  ul li {
    position: relative;
    width: 220px;
    height: 40px;
    line-height: 40px;
    background-color: #f8f9fb;
    border-radius: 2px;
    margin-right: 10px;
    margin-bottom: 10px;
    padding-right: 12px;
    color: #4e5e7b;
    font-size: 12px;

    .more {
      float: right;
      cursor: pointer;
    }

    .el-checkbox {
      flex: 1;
      padding-left: 12px;
    }
    .el-checkbox__label {
      font-size: 12px;
      color: #495057;
      font-weight: normal;
    }
    .icon {
      color: #adb5bd;
      cursor: pointer;
    }
    &.add-role {
      @include color_main();
      cursor: pointer;
      background: none;
      text-align: center;
      border: 1px rgba(217, 217, 217, 1) dashed;
    }
  }
}
</style>
